module.exports = __webpack_public_path__ + "static/media/loadimg.8ad80587.png";